import React from 'react'
import {Container, StartProcedureCard} from 'features/procedures/StartProcedureCard'

const ChooseProcedureTypeForAdmin = () => {
  return (
    <div>
      <div className="l-title-wrap">
        <h1 className="m-title-main">産休の手続きを選択</h1>
      </div>
      <Container>
        <StartProcedureCard to="/start_maternity/choose_employee" variant="start">
          産休の開始
        </StartProcedureCard>
        <StartProcedureCard to="/extend_maternity/choose_employee" variant="next">
          産休の届出情報の変更
        </StartProcedureCard>
        <StartProcedureCard to="/finish_maternity/choose_employee" variant="next">
          産休の終了
        </StartProcedureCard>
      </Container>
    </div>
  )
}

export default ChooseProcedureTypeForAdmin
